// 语言全集（单一来源，前后端共享）。Mini App 语言切换器、Admin 各处按语言输入的 UI
// 都从这里取，替换此前散落的硬编码 ["en-IN","zh","hi"]。每个 bot 通过
// bot_instance.languages 勾选启用其中哪些；en-IN 为强制兜底，始终启用、不可移除。
export const FALLBACK_LANG = "en-IN";

export interface LanguageOption {
  readonly code: string;
  // 母语显示名（展示给终端用户的语言切换器）。
  readonly name: string;
}

export const LANGUAGE_CATALOG: readonly LanguageOption[] = [
  { code: "en-IN", name: "English" },
  { code: "hi", name: "हिन्दी" },
  { code: "bn", name: "বাংলা" },
  { code: "ta", name: "தமிழ்" },
  { code: "te", name: "తెలుగు" },
  { code: "mr", name: "मराठी" },
  { code: "gu", name: "ગુજરાતી" },
  { code: "kn", name: "ಕನ್ನಡ" },
  { code: "ml", name: "മലയാളം" },
  { code: "pa", name: "ਪੰਜਾਬੀ" },
  { code: "zh", name: "中文" },
];

export const LANGUAGE_CODES: readonly string[] = LANGUAGE_CATALOG.map((l) => l.code);

const NAME_BY_CODE = new Map(LANGUAGE_CATALOG.map((l) => [l.code, l.name]));
export const languageName = (code: string): string => NAME_BY_CODE.get(code) ?? code.toUpperCase();

// 规整 bot 启用语言：去重、保证 en-IN 在内、按 catalog 顺序排列、剔除非 catalog 码。
export const normalizeBotLanguages = (input: readonly string[]): string[] => {
  const set = new Set(input);
  set.add(FALLBACK_LANG);
  return LANGUAGE_CODES.filter((c) => set.has(c));
};
